define('service/workflow.activity.service',['require','exports','module','underscore','backbone','appkit/appkit','datakit/util/getobject','bluebird','backbone.radio','jquery'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      Backbone  = require('backbone'),
      AppKit    = require('appkit/appkit'),
      getObject = require('datakit/util/getobject'),
      Promise   = require('bluebird'),
      Radio     = require('backbone.radio'),
      jQuery    = require('jquery');

  var WorkflowActivityService = {
    channelName: 'workflowActivityService',

    radioRequests: {
      areAllActivitiesComplete: 'areAllActivitiesComplete',
      determineTaskActivityCompletion: 'determineTaskActivityCompletion',
    },

    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    options: {},

    onAppConfigure: function() {
      AppKit.mergeRadioOptions(this, '');
    },

    shouldCheckTemplateModelForValidity: function(model, templateUrl) {
      var url = model.get('url');
      var jsonPath = model.get('jsonPath');
      var operator = model.get('operator');
      var operand = model.get('operand');

      // There is a very specific set of conditions specified in the workflow BPMN to indicate when we should check for a valid form.
      // When these are present, bypass the regular evaluation mechanism and use the currently registered templateObject instead since
      // it's the same data that is being requested by the workflow service.
      return url === templateUrl && jsonPath === '$.isValid' && operator === '==' && operand === 'true';
    },

    evaluateAndSetIsComplete: function(model, leftOperand, rightOperand, operator) {
      var isComplete = this.evaluateExpressOptions({
        leftOperand: leftOperand,
        rightOperand: rightOperand,
        operator: operator,
      });

      model.set('isComplete', isComplete);
    },

    determineTaskActivityCompletion: function(model) {
      var templateModel = Radio.request('AppKit.resourceService', 'resource', 'formTemplateModel');
      var templateUrl = templateModel ? [templateModel.urlRoot, templateModel.get('id')].join('/') : '';

      if (model instanceof Backbone.Collection) {
        model.each(this.determineTaskActivityCompletion, this);
        return;
      }
      if (!model.get('url')) {
        // Enables back-end to inform the front-end whether a task activity is already complete
        // without requiring the front-end to perform the fetch on the lines below
        return model.get('isComplete');
      }

      if (this.shouldCheckTemplateModelForValidity(model, templateUrl)) {
        this.evaluateAndSetIsComplete(model, templateModel.isValid(), model.get('operand'), model.get('operator'));
      } else {
        this.fetchData(model.attributes)
          .bind(this)
          .then(function(data) {
            this.evaluateAndSetIsComplete(model, data, model.get('operand'), model.get('operator'));
          })
          .catch(function(error) {
            console.error('An error occurred while fetching data evaluateAndSetIsComplete:', error);
          });
      }
    },

    fetchData: function(options) {
      options || (options = {});
      return Promise.resolve(jQuery.ajax(_.pick(options, ['url', 'method']))).then(function(response) {
        if (_.isString(options.jsonPath)) {
          if (options.jsonPath.indexOf('$.') === 0) {
            response = { $: response };
          }
          var value = getObject.get(response, options.jsonPath);
          // we want to force anything that is like null
          // i.e. undefined to be forced to be null
          return value == null ? null : value;
        }
        return response;
      })
      .catch(function(error) {
        console.error('An error occurred while fetching data:', error);
      });
    },

    evaluateExpressOptions: function(options) {
      options || (options = {});
      var leftOperand = String(options.leftOperand),
        rightOperand = String(options.rightOperand);
      switch (options.operator) {
        case '>':
          return leftOperand > rightOperand;
        case '<':
          return leftOperand < rightOperand;
        case '==':
          return leftOperand == rightOperand;
        case '!=':
          return leftOperand != rightOperand;
      }
    },

    areAllActivitiesComplete: function(activityCollection) {
      return activityCollection.all(function(activityModel) {
        return activityModel.get('isPassive') || activityModel.get('isComplete');
      });
    },
  };

  module.exports = WorkflowActivityService;
});

